import { Injectable, Inject } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { TimeApiService } from 'cbc-shared-lib';
import { Sgkc019aRequest, Sgkc019aResponse, SGKC019AService } from 'sg-api';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

/**
 * スライド調整単価登録API使用サービス
 * @export
 * @class UsedSgkc019aService
 */
@Injectable({
    providedIn: 'root'
})
export class UsedSgkc019aService {
    /**
       * コンストラクタ
       * @param {SGKC019AService} sGKC019AService
       * @param {ApiCommonService} apiCommonService
       * @param {TimeApiService} timeApiService
       * @param {FeaturesLibConfig} featuresLibConfig
       * @memberof UsedSgkc019aService
       */
    constructor(private sGKC019AService: SGKC019AService,
        private apiCommonService: ApiCommonService,
        private timeApiService: TimeApiService,
        @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

    /**
     * スライド調整単価登録API呼び出し
     * @param {Sgkc019aRequest} sgkc019aRequest
     * @return {Observable<Sgkc019aResponse>}
     * @memberof UsedSgkc019aService
     */
    registSlideTankatable(sgkc019aRequest: Sgkc019aRequest): Observable<Sgkc019aResponse> {

        // 年月日項目のフォーマット
        this.apiCommonService.convertElementInObject(sgkc019aRequest, Object.prototype.toString.call(new Date()), this.timeApiService.convertDateToString);

        return this.sGKC019AService.kC10WSGKC019APost(<Sgkc019aRequest>this.apiCommonService.setRequestCommon(sgkc019aRequest), 'response')
            .pipe(
                map(response => {
                    // エラーが設定されていないかチェックする
                    this.apiCommonService.checkError(response);
                    return response.body;
                }),
                timeout(Number(this.featuresLibConfig.httpTimeout)),
                catchError((err) => {
                    this.apiCommonService.dispErrorMessage(err, 'sgkc', 'SGKC019A');
                    return throwError(err.message);
                })
            );
    }

}
